import { UnavailableAlert } from "../../legacy/UnavailableAlert"

export default UnavailableAlert
